import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import dayjs from "dayjs";
import * as localizedFormat from 'dayjs/plugin/localizedFormat';
import { useTranslation } from "react-i18next";
//import LanguageDetector from 'i18next-browser-languagedetector';

function TemperatureSet({ temperatureData }) {
  require('dayjs/locale/de')
  const { t } = useTranslation();  
  const options = {  maximumFractionDigits: 1   }   
  const formatter = Intl.NumberFormat("en-de",options)
  const dangerLevelFlow= () => {
    if (temperatureData.flow?.outflow >3050)
      return 2
    if (temperatureData.flow?.outflow >1500)
      return 1    
    else return 0
  }
  dayjs.extend(localizedFormat)
  dayjs.locale('de') 
  
  return (
    <Container>      
    <Row>
    <Col>
  
    <div className="pb-5"> 
    <h1>{t('titleWaterCurrent')}</h1>
    <ListGroup variant="flush">
      <ListGroup.Item>{t('currentValue')} {formatter.format(temperatureData.water_latest?.temperature)} °C</ListGroup.Item>
      <ListGroup.Item>{t('minValue')} {formatter.format(temperatureData.water_agg?.min)} °C</ListGroup.Item>
      <ListGroup.Item>{t('maxValue')} {formatter.format(temperatureData.water_agg?.max)} °C</ListGroup.Item>
      <ListGroup.Item>{t('lastUpdated')} {dayjs(temperatureData.water_latest?.last_updated).format('L LT')}</ListGroup.Item>
    </ListGroup>
    </div>
    
    <div className="pb-5">
    <h1>{t('titleWaterflow')}</h1>
    <ListGroup variant="flush">
    {dangerLevelFlow(temperatureData)===0 ? <ListGroup.Item>{t('outflow')} {formatter.format(temperatureData.flow?.outflow)} m&sup3;/s</ListGroup.Item> : ''  }
    {dangerLevelFlow(temperatureData)===1 ? <ListGroup.Item variant="warning">{t('outflow')} {formatter.format(temperatureData.flow?.outflow)} m&sup3;/s</ListGroup.Item> : '' }
    {dangerLevelFlow(temperatureData)===2 ? <ListGroup.Item variant="danger">{t('outflow')} {formatter.format(temperatureData.flow?.outflow)} m&sup3;/s</ListGroup.Item> : '' }
      
    {temperatureData.flow?.level>650 ? <ListGroup.Item variant="warning">{t('level')} {formatter.format(temperatureData.flow?.level)} cm</ListGroup.Item> :
    <ListGroup.Item>{t('level')} {formatter.format(temperatureData.flow?.level)} cm</ListGroup.Item> }
    </ListGroup>
    </div>

    </Col>
    <Col >  
    <div className="pb-5">
    <h1>{t('titleAirCurrent')}</h1>
    <ListGroup variant="flush">
      <ListGroup.Item>{t('currentValue')} {formatter.format(temperatureData.air_latest?.temperature)} °C</ListGroup.Item>
      <ListGroup.Item>{t('minValue')} {formatter.format(temperatureData.air_agg?.min)} °C</ListGroup.Item>
      <ListGroup.Item>{t('maxValue')} {formatter.format(temperatureData.air_agg?.max)} °C</ListGroup.Item>
      <ListGroup.Item>{t('lastUpdated')} {dayjs(temperatureData.air_latest?.last_updated).format('L LT')}</ListGroup.Item>
    </ListGroup>
    </div>
    </Col>
    </Row>

    </Container>
  );
}

export default TemperatureSet;
